import { Input } from "@fragments";

export default function Message({ configRef }) {
    return (
        <Input.Text
            className="mt-4"
            placeholder="Insira uma mensagem"
            value={configRef.current.text}
            onInput={(v) => {
                configRef.current.text = v;
            }}
            label="Mensagem do post"
            size={500}
        />
    );
}
